import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const donationAnalytics = lazy(() => import('../../../container/donation-analytics'));

function PagesRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/donation-analytics`} component={donationAnalytics} />
    </Switch>
  );
}

export default PagesRoute;
